import { usePageTitle } from "@/hooks/usePageTitle";
import { Link } from "react-router-dom";
import { useState } from "react";
import axios from "axios";
import { formatApiError } from "@/lib/api";
import { Loader2, MailCheck } from "lucide-react";

const LOGO = "https://customer-assets-jai6qajn.emergentagent.net/job_inbody-powered/artifacts/cgjm5igj_FB%20Cover%20logo.png";

export default function ForgotPassword() {
  usePageTitle("Forgot Password");
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(false);
  const [err, setErr] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setErr(""); setBusy(true);
    try {
      await axios.post(`${process.env.REACT_APP_BACKEND_URL}/api/auth/forgot-password`,
        { email, origin_url: window.location.origin });
      setSent(true);
    } catch (e) {
      setErr(formatApiError(e.response?.data?.detail) || e.message);
    } finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-6 py-12 bg-[#F5F5F4]">
      <div className="w-full max-w-md bg-white rounded-2xl border border-[#E7E5E4] shadow-sm p-8">
        <Link to="/" className="flex justify-center mb-6"><img src={LOGO} alt="MBBC" className="h-14 w-14 object-contain" /></Link>
        {sent ? (
          <div className="text-center" data-testid="forgot-success">
            <MailCheck className="w-12 h-12 text-teal mx-auto" />
            <h2 className="mt-4 font-heading text-2xl text-navy">Check your inbox</h2>
            <p className="mt-2 text-sm text-[#57534E]">If <strong>{email}</strong> is registered, we've sent a password reset link. It's valid for 1 hour.</p>
            <Link to="/login" className="mt-6 inline-block text-teal font-medium text-sm">Back to login</Link>
          </div>
        ) : (
          <>
            <h2 className="font-heading text-2xl text-navy text-center">Forgot your password?</h2>
            <p className="mt-1 text-center text-sm text-[#57534E]">Enter your email and we'll send you a reset link.</p>
            <form onSubmit={submit} className="mt-6 space-y-4">
              <input data-testid="forgot-email" type="email" required placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)}
                className="w-full bg-white border border-[#E7E5E4] rounded-lg px-4 py-2.5 focus:outline-none focus:ring-2 focus:ring-teal/20 focus:border-teal" />
              {err && <p data-testid="forgot-error" className="text-sm text-red-600">{err}</p>}
              <button data-testid="forgot-submit" disabled={busy} type="submit"
                className="w-full bg-navy text-white hover:bg-navy-dark transition-colors rounded-lg py-3 font-medium flex items-center justify-center gap-2 disabled:opacity-60">
                {busy && <Loader2 className="w-4 h-4 animate-spin" />} Send reset link
              </button>
            </form>
            <p className="mt-5 text-center text-sm text-[#57534E]">Remembered it? <Link to="/login" className="text-teal font-medium">Log in</Link></p>
          </>
        )}
      </div>
    </div>
  );
}
